import Box from '@passkeys/ui/box';

import Subpage from '@/ui/components/subpage';
import { EMBEDDABLE_SIGNER } from '@/ui/constants';
import exodus from '@/ui/exodus';
import useExpandedEffect from '@/ui/hooks/use-expanded-effect';
import Analytics from './components/analytics.js';
import Appearance from './components/appearance.js';
import Backup from './components/backup.js';
import DeveloperMode from './components/developer-mode.js';
import Disconnect from './components/disconnect.js';
import Export from './components/export.js';
import Version from './components/version.js';

function SettingsPage() {
  useExpandedEffect(() => {
    exodus.analytics.track({
      event: 'SettingsView',
    });
  }, []);

  return (
    <Subpage
      title="Settings"
      className="flex h-full flex-col items-center overflow-hidden pb-6"
    >
      <Box className="overflow-y-auto scrollbar-hide">
        <ul className="divide-y divide-solid divide-black/6 px-4 theme-dark:divide-neutral-600">
          {__STANDALONE_MODE__ && (
            <li>
              <Appearance />
            </li>
          )}
          <li>
            <Backup />
          </li>
          <li>
            <Export />
          </li>
          <li>
            <DeveloperMode />
          </li>
          {EMBEDDABLE_SIGNER && (
            <li>
              <Analytics />
            </li>
          )}
          <li>
            <Disconnect />
          </li>
        </ul>
      </Box>
      <Version />
    </Subpage>
  );
}

export default SettingsPage;
